import { render, staticRenderFns } from "./SupplyPointForm.vue?vue&type=template&id=33dada0a"
import script from "./SupplyPointForm.vue?vue&type=script&lang=js"
export * from "./SupplyPointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports